import { Box, Grid, Stack, Text3, Text6, skinVars } from "@telefonica/mistica";
import { useScreenSize, useWindowHeight, useWindowWidth } from "@telefonica/mistica/dist/hooks";
import React from "react";
import { HEIGHT_GRID_LOGO } from "../../enum/heightGridLogo";

interface IProps {
	icon?: React.ReactNode;
	title: string;
	description: React.ReactNode;
	children?: React.ReactNode;
	slot?: React.ReactNode;
	width?: number;
	isFullHeight?: boolean;
}

export const FeedbackContainer: React.FC<IProps> = (props) => {
	const { icon, title, description, children, slot, width, isFullHeight = true } = props;

	const screenHeight = useWindowHeight();
	const screenWidth = useWindowWidth();
	const { isDesktopOrBigger } = useScreenSize();

	return (
		<Grid height={isFullHeight ? screenHeight - HEIGHT_GRID_LOGO : "100%"} justifyContent="center">
			<Box width={screenWidth < 1024 ? "100%" : width ? width : 600} className="space-between-vertical">
				<Box paddingBottom={isDesktopOrBigger ? 16 : 0}>
					{icon && <Box paddingTop={32} paddingBottom={24}>
						{icon}
					</Box>}
					<Stack space={8}>
						<Text6>{title}</Text6>
						<Text3 color={skinVars.colors.textSecondary} light>
							{description}
						</Text3>
						<Box paddingTop={24}>{slot}</Box>
					</Stack>
				</Box>
				{children && <Box paddingBottom={32}>{children}</Box>}
			</Box>
		</Grid>
	);
};
